import { render, staticRenderFns } from "./PointModal.vue?vue&type=template&id=29b873ac"
import script from "./PointModal.vue?vue&type=script&lang=ts"
export * from "./PointModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports